import CallbackForm from "../../shares/CallbackForm/CallbackForm";
import "./callback.scss";

function Callback() {
    return (
        <div className="callback" id="Contacts">
            <h1 className="callback-title">
                Contacts
            </h1>
            <div className="callback-details">
                <div className="callback-info">
                    <ul className="callback-text">
                        <li>Roman Tyrtychko</li>
                        <li>tyrtychko.r404man@gmail.com</li>
                        <li>@r404man</li>
                        <li>8 777 518 58 85</li>
                        <li>8:00 - 19:00</li>
                    </ul>
                    <div className="callback-image">
                        <img src="assets/contacts.png" alt="Contacts background" />
                    </div>
                </div>
                <div className="callback-form">
                    <CallbackForm />
                </div>
            </div>
        </div>
    )
}

export default Callback